/* eslint-disable react-hooks/exhaustive-deps */
import {useEffect, useState, useMemo} from 'react';
import {getLoginUrl, getRegistrationUrl} from '../utils/universalLoginUrls';

const changeTravelerLinkToUniversalLogin = (
    getUrlFn,
    items = [],
    marketingPreferencePageType,
    marketingPreferencePageName
) =>
    items.map((item) =>
        item.cssClass === 'se-traveler-login'
            ? {
                ...item,
                link: getUrlFn(
                    marketingPreferencePageType,
                    marketingPreferencePageName
                ),
            }
            : item
    );

const useLoginSignUpData = (
    {
        data,
        useUniversalLogin,
        marketingPreferencePageType,
        marketingPreferencePageName,
    },
    getUrlFn
) => {
    const [dataState, setLoginState] = useState(data);

    useEffect(() => {
        if (data) {
            const newState = {
                ...data,
                ...(useUniversalLogin && {
                    items: changeTravelerLinkToUniversalLogin(
                        getUrlFn,
                        data.items,
                        marketingPreferencePageType,
                        marketingPreferencePageName
                    ),
                }),
            };

            setLoginState(newState);
        }
    }, [
        data,
        useUniversalLogin,
        marketingPreferencePageName,
        marketingPreferencePageType,
    ]);

    return dataState;
};

const useLoginData = ({login, ...otherProps}) => {
    const props = useMemo(() => ({data: login, ...otherProps}), [login]);
    const loginDataState = useLoginSignUpData(props, getLoginUrl);
    return loginDataState;
};

const useSignUpData = ({login, signUp, ...otherProps}) => {
    const props = useMemo(
        () => ({data: {...signUp, ...login}, ...otherProps}),
        [login, signUp]
    );
    const signUpDataState = useLoginSignUpData(props, getRegistrationUrl);
    return signUpDataState;
};

export {useLoginData, useSignUpData};
